var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0V12H52V0H44ZM16.8906 11.2344L11.2344 16.8906L19.7188 25.375L25.375 19.7188L16.8906 11.2344ZM79.1094 11.2344L70.625 19.7188L76.2812 25.375L84.7656 16.8906L79.1094 11.2344ZM48 20C32.5827 20 20 32.5827 20 48C20 59.0712 26.6245 68.409 36 72.9375V84C36 88.3723 39.6277 92 44 92H52C56.3723 92 60 88.3723 60 84V72.9375C69.3755 68.409 76 59.0712 76 48C76 32.5827 63.4173 20 48 20ZM48 28C59.0947 28 68 36.9053 68 48C68 56.7374 62.4213 64.0914 54.6641 66.8359L52 67.7734V84H44V67.7734L41.3359 66.8359C33.5787 64.0914 28 56.7374 28 48C28 36.9053 36.9053 28 48 28ZM0 44V52H12V44H0ZM84 44V52H96V44H84ZM19.7188 70.625L11.2344 79.1094L16.8906 84.7656L25.375 76.2812L19.7188 70.625ZM76.2812 70.625L70.625 76.2812L79.1094 84.7656L84.7656 79.1094L76.2812 70.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIconBlack);
export default __webpack_public_path__ + "static/media/light-icon-black.e7257500.svg";
export { ForwardRef as ReactComponent };